import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';

// eslint-disable-next-line import/prefer-default-export
export const ColStyled = styled(Col)`
  ${({ theme, disableBottomPadding, lastItem }) => {
    const mediumUp = theme.mediumUp();
    let paddingBottom = rem(10); // mobile default

    if(mediumUp){
      if(disableBottomPadding){
        paddingBottom = 0;
      }else {
        paddingBottom = rem(10);
      }
    }

    if(lastItem){
      paddingBottom = 0;
    }

    return css`
      padding-bottom: ${paddingBottom};
    `;
  }
}`;
